import React from 'react';
import CardBody from './CardBody';
import { warnOnce } from './utils';
export default function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return React.createElement(CardBody, props);
}


//////////////////
// WEBPACK FOOTER
// ../reactstrap/es/CardBlock.js
// module id = 1300
// module chunks = 22